export default () => ({
  footerSelector: "[data-footer]",
  footerObserver: "[data-footer-container]",
  ticking: false,

  init() {
    this.$nextTick(() => {
      this.adjustFixedComponents()
      this.observeFooter()
      this.setupEventListeners()
    })
  },

  setupEventListeners() {
    const handler = this.debouncedAdjust.bind(this)
    window.addEventListener("scroll", handler, { passive: true })
    new ResizeObserver(handler).observe(document.body)
  },

  observeFooter() {
    const footer = document.querySelector(this.footerObserver)

    if (footer) {
      new IntersectionObserver(
        ([entry]) => {
          this.adjustFixedComponents(entry.intersectionRatio)
        },
        { threshold: [0, 1] },
      ).observe(footer)
    }
  },

  debouncedAdjust() {
    if (!this.ticking) {
      this.ticking = true
      requestAnimationFrame(() => {
        this.adjustFixedComponents()
        this.ticking = false
      })
    }
  },

  adjustFixedComponents() {
    const footer = document.querySelector(this.footerSelector)

    if (!footer) return

    const footerTop = footer.getBoundingClientRect().top
    const viewportHeight = window.innerHeight
    const isOverlapping = footerTop < viewportHeight
    const threshold = 50

    document
      .querySelectorAll("[data-sticky-bottom], [data-layout-bottom-fixed]")
      .forEach((component) => {
        const spacer = this.getOrCreateSpacer(component)
        const shouldBeAbsolute = isOverlapping && footerTop - viewportHeight < threshold

        if (shouldBeAbsolute) {
          this.setAbsolute(component, spacer)
        } else {
          this.setFixed(component, spacer)
        }
      })
  },

  getOrCreateSpacer(component) {
    let spacer = component.nextElementSibling

    if (!spacer || !spacer.hasAttribute("data-spacer")) {
      spacer = document.createElement("div")
      spacer.setAttribute("data-spacer", "true")
      component.parentNode.insertBefore(spacer, component.nextSibling)
    }

    if (spacer.dataset.spacer === "false") {
      spacer.style.height = "0px"
    } else {
      spacer.style.height = `${component.offsetHeight}px`
    }

    return spacer
  },

  setAbsolute(component, spacer) {
    this.toggleClass(component, "absolute", true)
    this.toggleClass(component, "fixed", false)
    this.toggleClass(spacer, "block", true)

    if (spacer.dataset.spacer !== "false") {
      spacer.style.height = `${component.offsetHeight}px`
    }
  },

  setFixed(component, spacer) {
    this.toggleClass(component, "absolute", false)
    this.toggleClass(component, "fixed", true)
    this.toggleClass(spacer, "block", false)

    if (spacer.dataset.spacer !== "false") {
      spacer.style.height = `${component.offsetHeight}px`
    }
  },

  toggleClass(element, className, shouldAdd) {
    element.classList.toggle(className, shouldAdd)
  },
})
